/**
 * Endpoint names are ONE global flat namespace across every feature's
 * `provideConfig` chunk, so these must be unique platform-wide — hence the
 * `notification` prefix on all of them.
 */
export const NOTIFICATION_API_ROUTES = {
  notificationList: 'notifications',
  notificationUnreadCount: 'notifications/unread-count',
  notificationMarkAllRead: 'notifications/mark-all-read',
  notificationDismissAll: 'notifications/dismiss-all',
  notificationMarkRead: 'notifications/${notificationId}/read',
  notificationById: 'notifications/${notificationId}',
  notificationDeliveries: 'notifications/${notificationId}/deliveries',

  notificationChannels: 'notifications/channels',
  notificationChannelById: 'notifications/channels/${channelId}',
  notificationChannelWebhook: 'notifications/channels/${channelId}/webhook',
  notificationChannelTest: 'notifications/channels/${channelId}/test',

  notificationLists: 'notifications/distribution-lists',
  notificationListById: 'notifications/distribution-lists/${listId}',
  notificationListMembers: 'notifications/distribution-lists/${listId}/members',
  notificationListMemberById: 'notifications/distribution-lists/${listId}/members/${memberId}',

  notificationSubscriptions: 'notifications/subscriptions',
  notificationSubscriptionById: 'notifications/subscriptions/${subscriptionId}',
  notificationSubscriptionMatch: 'notifications/subscriptions/match',

  notificationTestSend: 'notifications/test-send',
  notificationOutbox: 'notifications/deliveries',
  notificationOutboxRetry: 'notifications/deliveries/${deliveryId}/retry',
};
